<template>
    <div class="draft bg-white" :style="{minHeight:minHeight+'px'}">
        <!-- <router-view/> -->
        <headerCom></headerCom>
        <div class="activity-top flex-lr">
            <div class="activity-menu-list flex-lm">
                <div v-for="(item,index) in statuslist"
                     :class="['activity-menu', item.isactive==true ? 'black-font' : 'gray-font', 'font-size16']">
                    {{item.name}}
                </div>
            </div>
        </div>
        <!-- 征稿列表 -->
        <keep-alive>
            <list :scrolltop="scrolltop" v-on:invite="invite" action="topath"></list>
        </keep-alive>
        <el-dialog
                title="分享此活动"
                :visible.sync="dialogVisible"
                width="50%" append-to-body
                :before-close="handleClose" class="fotoo">
            <div>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="分享链接" name="link">
                        <div class="block">
                            <div class="link-tips">以网页链接形式在QQ、B站、小红书、微博、豆瓣、知乎等App或网站分享</div>
                            <el-row type="flex" style="padding-top: 20px;">
                                <el-col>
                                    <textarea class="link-textarea" readonly disabled>https://pfotoo.com/#/activity/{{aesId}}</textarea>
                                </el-col>
                                <el-col :span="6"><el-button type="success" round @click="copy">复制链接</el-button></el-col>
                            </el-row>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="微信分享" name="wechat">
                        <div class="block" style="text-align: center;padding-top: 40px;">
                            <el-image :src="codeurl">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                            </el-image>
                            <div style="margin-top: 20px;">
                                <el-button type="success" round @click="downcode" style="width: 200px;">保存</el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>

    </div>

</template>

<script>
  import headerCom from '../header.vue'
  import list from '../list.vue'
  import App from '../../util/comfun'
  export default {
    name: 'draft',
    data() {
      return {
        minHeight: window.innerHeight - 82,
        statuslist: [
          {
            name: '全部',
            status: 0,
            isactive: true
          },
          // {
          //   name:'进行中',
          //   status:1,
          //   isactive:false
          // },
          // {
          //   name:'已结束',
          //   status:2,
          //   isactive:false
          // }
        ],
        openid: JSON.parse(localStorage.getItem('userinfo')).openid,
        userinfo: JSON.parse(localStorage.getItem('userinfo')),
        scrolltop: 0,
        dialogVisible:false,
        activeName: 'link',
        aesId:'',
        codeurl:'',
      }
    },
    components: {
      headerCom,
      list,
    },
    methods: {
      handleClose(done) {
        done();
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      //邀请投稿
      invite(item) {
        this.item=item
        this.dialogVisible=true
        this.aesId=item.aesId
        App.System.Qrcode({
          autoColor:false,
          inHyaline:false,
          lineColor:'0,0,0',
          page:'pages/draftworks/work',
          scene:encodeURIComponent('id='+item.id),
          width:300
        },'URL').then(codeurl=>{
          this.codeurl=codeurl
        })
      },
      handleScroll() {
        console.log('rrrr')
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.scrolltop = scrollTop;
      },
      copy(){
        let createInput = document.createElement("input");
        createInput.value = 'https://pfotoo.com/#/activity/'+this.item.aesId;
        document.body.appendChild(createInput);
        createInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        createInput.style.display = "none";
        this.$message({ message: "复制成功", type: "success" });
      },
      downcode(){
        App.download(this.codeurl,this.item.name)
      },
    },
    beforeRouteLeave(to, from, next) {
      console.log(to, from, next)
      if (to.name == 'detail') {
        from.meta.keepAlive = true;
      } else {
        from.meta.keepAlive = false;
        this.$destroy();
      }
      next();
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)

    },

  }
</script>

<style>
    .activity-top {
        width: 100%;
        padding: 20px 25px 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .activity-add {
        width: 95px;
        height: 36px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: 500;
    }

    .activity-menu {
        padding: 0 5px;
        margin-right: 5px;
        cursor: pointer;
    }

    .code-mask {
        background: rgba(0, 0, 0, .85);
        z-index: 100;
    }

    .code-content {
        width: 450px;
        height: 450px;
        border-radius: 10px;
        padding: 40px 0 50px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        transform: scale(0);
        transition: transform .5s ease;
    }

    .code-content.active {
        transform: scale(1);
    }

    .invite-code {
        width: 215px;
        height: 215px;
        margin: 30px 0;
    }

    .code-close {
        position: absolute;
        right: 30px;
        top: 30px;
        cursor: pointer;
    }

    .link-tips{
        height: 22px;
        opacity: 1;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #999999;
        line-height: 22px;
        margin-top: 60px;
        margin-bottom: 20px;
    }
    .link-textarea{
        width: calc(100% - 25px);
        border-width: 0px;
        border-bottom: 1px solid #e0e0e0;
        margin-right: 25px;
        background-color: #fefefe;

        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        line-height: 25px;
        resize:none;
    }
</style>



// WEBPACK FOOTER //
// src/components/list/index.vue